import Vue from "vue";
import { url } from "../../const/base";
import { api_url } from "../../const/base";

export default {
    data() {
        return {
            baseUrl: url
        };
    },

    state: {
        loaded: false,
        instanceId: -1,
        apiUrl: api_url,
        userId: false,
        userRole: false,
        mbtiProfile: {
            mbtiClassification: false,
            trueColorClassification: false
        },
        userImpact: false,
        dcpProfileText: false,
        teamCode: false,
        respondent: false,
        challengeToken: false,
        emailVerificationCompleted: false,
        currentBlock: 0,
        transitorScore: 0,
        transitorShown: false,
        transitorAnim: false,
        transitorSound: false,
        soundtrackPlaying: false,
        lastBlock: false,
        blocks: [],
        globalSettings: {},
        globalGroups: {},
        answerLogs: [],
        sdgLogs: [],
        nextButton: false,
        nextButtonClass: {
            btn: true,
            "btn-progres": true,
            "btn-progres-utrecht-whiteLine": false
        },
        underWater: false,
        nextButtonAction: function() {}
    },
    mutations: {
        setEmailVerificationCompleted(state, action) {
            state.emailVerificationCompleted = true;
        },

        setNextButtonAction(state, action) {
            state.nextButtonAction = action;
        },

        setTransitor(state, obj) {
            state.transitorAnim = obj.transitor_animation;
            state.transitorSound = obj.transitor_sound;
        },

        setTransitorSound(state, sound) {
            state.transitorSound = sound;
        },

        showTransitorScore(state, action) {
            state.transitorShown = action;
        },

        IncreaseTransitorScore(state, quantity) {
            state.transitorScore += quantity;
        },

        setSoundTrackState(state, audioInstance) {
            state.soundtrackPlaying = audioInstance;
        },

        setNextButton(state, show) {
            state.nextButton = show;
        },

        setInstanceId(state, id) {
            state.instanceId = id;
        },

        setUserId(state, id) {
            state.userId = id;
        },

        setUserRole(state, id) {
            state.userRole = id;
        },

        setMbtiProfile(state, obj) {
            state.mbtiProfile.mbtiClassification = obj.mbtiClassification;
            state.mbtiProfile.trueColorClassification =
                obj.trueColorClassification;
        },

        setDcpProfileText(state, profileTextArrayJson) {
            state.dcpProfileText = profileTextArrayJson;
        },

        setUserImpact(state, impact) {
            state.userImpact = impact;
        },

        setTeamCode(state, id) {
            state.teamCode = id;
        },

        setChallengeToken(state, token) {
            state.challengeToken = token;
        },

        setRespondentId(state, id) {
            state.resp_id = id;
        },

        setRespondent(state, obj) {
            state.respondent = obj;
        },
        setGameLoaded(state) {
            state.loaded = true;
        },

        incrementCurrentBlock(state) {
            state.currentBlock++;
        },
        resetCurrentBlock(state) {
            state.currentBlock = 0;
        },

        clearBlocks(state, block) {
            state.blocks = [];
        },

        addBlock(state, block) {
            state.blocks.push(block);
        },

        setLastBlock(state) {
            state.lastBlock = state.currentBlock >= state.blocks.length - 1;
        },

        setNextButtonClass(state, obj) {
            state.nextButtonClass = obj;
        },

        setUnderWater(state, bool) {
            state.underWater = bool;
        },

        logAnswers(state, data) {
            let block = state.blocks[data.block];
            if (block == undefined) return;
            let stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            let round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["answers"] = data.answers;
        },

        logSdgs(state, data) {
            let block = state.blocks[data.block];
            if (block == undefined) return;
            let stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            let round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["sdgs"] = data.sdgs;
        },

        setGlobalSettings(state, settings) {
            state.globalSettings = settings;
        },

        setGlobalGroups(state, groups) {
            state.globalGroups = groups;
        },

        setRoundScore(state, data) {
            let block = state.blocks[data.block];
            if (block == undefined) return;
            let stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            let round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["score"] = data.score;
        }
    },
    actions: {

        setEmailVerificationCompleted(store) {
            return new Promise((resolve, reject) => {
                //console.log('teamcode: '+id);
                store.commit("setEmailVerificationCompleted", true);
                resolve();
            });
        },

        setTransitorSound(store, sound) {
            return new Promise((resolve, reject) => {
                //console.log(object);
                store.commit("setTransitorSound", sound);
                resolve();
            });
        },

        setNextButtonClass(store, object) {
            return new Promise((resolve, reject) => {
                //console.log(object);
                store.commit("setNextButtonClass", object);
                resolve();
            });
        },
        showTransitorScore(store, action) {
            return new Promise((resolve, reject) => {
                store.commit("showTransitorScore", action);
                resolve();
            });
        },
        increaseTransitorScore(store, quantity) {
            return new Promise((resolve, reject) => {
                store.commit("IncreaseTransitorScore", quantity);
                resolve();
            });
        },

        setUserRole(store, id) {
            return new Promise((resolve, reject) => {
                //console.log('role: '+id);
                store.commit("setUserRole", id);
                resolve();
            });
        },

        setMbtiProfile(store, obj) {
            return new Promise((resolve, reject) => {
                //console.log('role: '+id);
                store.commit("setMbtiProfile", obj);
                resolve();
            });
        },

        setUserImpact(store, impact) {
            return new Promise((resolve, reject) => {
                //console.log('teamcode: '+id);
                store.commit("setUserImpact", impact);
                resolve();
            });
        },

        setTeamCode(store, id) {
            return new Promise((resolve, reject) => {
                //console.log('teamcode: '+id);
                store.commit("setTeamCode", id);
                resolve();
            });
        },

        setChallengeToken(store, token) {
            return new Promise((resolve, reject) => {
                console.log('challengeToken: '+token);
                store.commit("setChallengeToken", token);
                resolve();
            });
        },

        setRespondentId(store, id) {
            return new Promise((resolve, reject) => {
                //console.log('setRespondentId: '+id);
                store.commit("setRespondentId", id);
                resolve();
            });
        },

        setRespondent(store, obj) {
            return new Promise((resolve, reject) => {
                //console.log('setRespondent: '+obj);
                store.commit("setRespondent", obj);
                resolve();
            });
        },

        toNextBlock(store) {
            return new Promise((resolve, reject) => {
                store.commit("incrementCurrentBlock");
                this.dispatch("setBlock").then(() => {
                    resolve();
                });
            });
        },

        setBlock(store) {
            return new Promise((resolve, reject) => {
                this.dispatch("setBlockData", {
                    blockType:
                        store.state.blocks[store.state.currentBlock].type,
                    settings:
                        store.state.blocks[store.state.currentBlock].settings,
                    stages:
                        store.state.blocks[store.state.currentBlock]
                            .data_structure
                }).then(() => {
                    store.commit("setLastBlock");
                    resolve();
                });
            });
        },

        loadGameData(store, teamcode) {
            return new Promise((resolve, reject) => {

                if (typeof teamcode !== "undefined") {
                    store.commit("setTeamCode", teamcode);
                }

                //console.log(this.$route.query.teamcode);

                //store.commit("setRespondentId" , teamcode);

                /* store.dispatch("applyData", data).then(() => {
                    resolve();
                });
				return;
				*/


                // .get(
                //         store.state.apiUrl +
                //             "api/v2/loadinstance?id=32&teamcode=" +
                //             teamcode
                //     )
                //     .then(response => {

                //Vue.http.get('data.json').then(response => {
                    
                Vue.http.get(
                        store.state.apiUrl +
                            "api/v2/loadinstance?id=26teamcode=" +
                            teamcode
                    )
                    .then(response => {
                        
                        let data = response.body;
                        store.dispatch("applyData", data).then(() => {
                            resolve();
                        });
                    })
                    .catch(response => {
                        reject("Could not load data");
                    });
            });
        },

        applyData(store, data) {
            return new Promise((resolve, reject) => {
                store.commit("clearBlocks");
                store.commit("setGlobalSettings", JSON.parse(data.settings));
                store.commit("setGlobalGroups", data.groups);
                store.commit("setUserId", data.session_id);

                store.commit("setRespondent", data.respondent);

                store.commit("setInstanceId", data.id);

                store.commit("setTransitor", JSON.parse(data.settings).assets);

                store.commit("setDcpProfileText", data.dcpText);


                for (let blockData of data.blockData) {
                    store.commit("addBlock", blockData);
                }
                store.dispatch("setBlock").then(() => {
                    store.commit("setGameLoaded");
                    resolve();
                });
            });
        },

        showNextButton(store, classObj) {
            return new Promise((resolve, reject) => {
                store.commit("setNextButton", true);
                store.commit(
                    "setNextButtonClass",
                    classObj != undefined
                        ? classObj
                        : {
                              btn: true,
                              "btn-progres": true,
                              "btn-progres-utrecht-whiteLine": false
                          }
                );
                resolve();
            });
        },

        setNextButtonAction(store, action) {
            return new Promise((resolve, reject) => {
                store.commit("setNextButtonAction", action);
                resolve();
            });
        },

        hideNextButton(store) {
            return new Promise((resolve, reject) => {
                store.commit("setNextButton", false);
                resolve();
            });
        },

        setUnderWater(store, bool) {
            return new Promise((resolve, reject) => {
                store.commit("setUnderWater", bool);
                resolve();
            });
        },

        logAnswers(store, answers) {
            return new Promise((resolve, reject) => {
                let data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    answers: answers
                };

                store.commit("logAnswers", data);

                let log = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    block_id:
                        store.getters.blocks[store.getters.currentBlock].id,
                    round_id: store.getters.currentRound,
                    gametype: store.getters.roundData.gametype,
                    answers: answers
                };

                Vue.http
                    .post(store.state.apiUrl + "api/v2/saveroundscore", log)
                    .then(response => {
                        //console.log('Response from saveroundscore:');
                        //console.log(response.body);
                    })
                    .catch(response => {
                        //console.log(response);
                    });

                resolve();
            });
        },

        saveAnswerLogs(store) {
            // NOT USED

            return new Promise((resolve, reject) => {
                let body = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    answers: store.getters.answerLogs,
                    pointsjson: store.getters.scores
                };

                Vue.http
                    .post(store.state.apiUrl + "api/v2/savescore", body)
                    .then(response => {
                        //console.log(response.body);
                        resolve();
                    })
                    .catch(response => {
                        //console.log(response);
                        reject("Could not save answers.");
                    });
            });
        },

        setRoundScore(store, score) {
            return new Promise((resolve, reject) => {
                let data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    score: score
                };

                store.commit("setRoundScore", data);
                resolve();
            });
        },

        logSdgs(store, sdgs) {
            return new Promise((resolve, reject) => {
                let data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    sdgs: sdgs
                };

                store.commit("logSdgs", data);

                let log = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    block_id:
                        store.getters.blocks[store.getters.currentBlock].id,
                    round_id: store.getters.currentRound,
                    gametype: store.getters.roundData.gametype,
                    sdgs: sdgs
                };

                // Vue.http
                //     .post(store.state.apiUrl + "api/v2/saveroundscore", log)
                //     .then(response => {
                //         //console.log('Response from saveroundscore:');
                //         //console.log(response.body);
                //     })
                //     .catch(response => {
                //         //console.log(response);
                //     });

                resolve();
            });
        }
    },

    getters: {
        emailVerificationCompleted(state) {
            return state.emailVerificationCompleted;
        },
        instanceId(state) {
            return state.instanceId;
        },
        userId(state) {
            return state.userId;
        },
        gameLoaded(state) {
            return state.loaded;
        },
        blocks(state) {
            return state.blocks;
        },
        currentBlock(state) {
            return state.currentBlock;
        },
        lastBlock(state) {
            return state.lastBlock;
        },
        nextButtonShown(state) {
            return state.nextButton;
        },
        nextButtonClass(state) {
            return state.nextButtonClass;
        },
        nextButtonAction(state) {
            return state.nextButtonAction;
        },
        underWater(state) {
            return state.underWater;
        },
        transitorScore(state) {
            return state.transitorScore;
        },
        transitorShown(state) {
            return state.transitorShown;
        },
        transitorAnim(state) {
            return state.transitorAnim;
        },
        transitorSound(state) {
            return state.transitorSound;
        },
        answerLogs(state) {
            return state.answerLogs;
        },
        sdgLogs(state) {
            return state.sdgLogs;
        },
        globalSettings(state) {
            return state.globalSettings;
        },
        globalGroups(state) {
            return state.globalGroups;
        },
        userRole(state) {
            return state.userRole;
        },
        userImpact(state) {
            return state.userImpact;
        },
        mbtiProfile(state) {
            return state.mbtiProfile;
        },
        teamCode(state) {
            return state.teamCode;
        },
        challengeToken(state) {
            return state.challengeToken;
        },
        resp_id(state) {
            return state.resp_id;
        },
        respondent(state) {
            return state.respondent;
        },
        dcpProfileText(state) {
            return state.dcpProfileText;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/game.js